<template>
    <v-container grid-list-xl>
        <v-layout my-6>
            <v-btn @click="$router.go(-1)" class="my-auto">
                <v-icon>navigate_before</v-icon>
                {{ $t('back') }}
            </v-btn>

            <v-flex ml-12 xs10>
                <div class="display-3 font-weight-thin">{{ $i18n.t('tests') }}</div>
            </v-flex>

            <v-spacer/>

            <v-btn @click="createTest" class="my-auto mx-4" color="teal">
                {{ $t('addTest') }}
                <v-icon right>add</v-icon>
            </v-btn>
        </v-layout>

        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="getTests"
                    :items-per-page="15"
                    :loading="isLoading"
                    :loading-text="$i18n.t('loading')"
                    :no-results-text="$t('noResults')"
                    :no-data-text="$t('noData')"
                    sort-by="lastUpdatedAt"
                    :sort-desc="true"
                    @click:row="viewTest">

                    <template v-slot:item.lastUpdatedAt="{ item }">
                        {{ toDate(item.lastUpdatedAt) }}
                    </template>

                    <template v-slot:item.testDate="{ item }">
                        {{ toDate(item.testDate) }}
                    </template>

                    <template v-slot:item.state="{ item }">
                        <v-tooltip open-on-hover open-delay=300 max-width=220 bottom>
                            <template v-slot:activator="{ on }">
                                <div v-on="on" v-if="item.done" class="subtitle-2 font-weight-light deep-orange--text">{{ $i18n.t('done') }}</div>
                                <div v-on="on" v-else-if="item.final" class="subtitle-2 font-weight-light blue-grey--text">{{ $i18n.t('final') }}</div>
                                <div v-on="on" v-else-if="item.draft" class="subtitle-2 font-weight-light brown--text">{{ $i18n.t('draft')}}</div>
                            </template>

                            <span v-if="item.done">{{ $i18n.t('doneTooltip') }}</span>
                            <span v-else-if="item.final">{{ $i18n.t('finalTooltip') }}</span>
                            <span v-else-if="item.draft">{{ $i18n.t('draftTooltip') }}</span>
                        </v-tooltip>

                    </template>
                </v-data-table>
            </v-card-text>

            <v-dialog v-model="createTestDialog" max-width="1300px">
                <CreateTest/>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import toDatetime from '@/components/dateParser';
import toDate from '@/components/dateParser';
import CreateTest from '@/components/Test/CreateTest'

export default {
    methods: {
        createTest(){
            this.$store.commit('newTest')
            this.$store.commit('setCreateTestDialog', true)
        },
        viewTest(test){
            this.$store.commit('setRemovingTest', false)
            this.$store.commit('setMakingTestFinal', false)
            this.$router.push('/tests/' + test.id)
        }
    },

    created(){
        this.$store.dispatch('getTests')
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTests',
            'getCreateTestDialog',
        ]),
        headers() { 
            return[
                { text: this.$t('title'), value: 'title', align: 'left' },
                { text: this.$t('lastUpdatedAt'), value: 'lastUpdatedAt', align: 'center'},
                { text: this.$t('testDate'), value: 'testDate', align: 'center'},
                { text: this.$t('state'), value: 'state', align: 'right', sortable: false, width: "10px"},
            ]
        },
        createTestDialog: {
            get() { return this.getCreateTestDialog },
            set(value) { this.$store.commit('setCreateTestDialog', value) },
        },
    },

    components: {
        CreateTest,
    },

    mixins: [toDate, toDatetime],
}
</script>
